<template>
  <v-dialog v-model="internalValue" max-width="576" persistent>
    <v-card class="donation-flow">
      <!-- header like image picker -->
      <v-card-title class="d-flex justify-space-between align-center pa-4 pb-2">
        <span class="modal-title">{{ t('taxReductionInfo.title') }}</span>
        <v-btn
          icon
          variant="text"
          :aria-label="t('aria.label.close')"
          @click="internalValue = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <p class="pt-4 pb-4 tax-info-intro">{{ t('taxReductionInfo.info') }}</p>
        <ul class="pt-3">
          <li
            v-for="prerequisite in prerequisites"
            :key="prerequisite"
          >
            {{ prerequisite }}
          </li>
        </ul>
        <p class="subtitle-2">{{ t('taxReductionInfo.moreInfo') }}</p>
      </v-card-text>
      <v-divider />
      <v-card-actions class="my-2 mr-4">
        <v-spacer />
        <v-btn id="taxModalCloseButton" variant="outlined" density="comfortable" color="primary" class="primary--text" @click="internalValue = false" style="width: 200px !important; border-radius: 8px !important">
          {{ t('generic.labels.close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import { defineComponent, computed, watch } from 'vue';
import { useLabel } from '@/composables/useLabel';
import i18n from '@/plugins/i18n';

export default defineComponent({
  name: 'TaxReductionModalComponent',
  props: {
    modelValue: { type: Boolean, default: false },
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const { t } = useLabel();

    const internalValue = computed({
      get: () => props.modelValue,
      set: (val: boolean) => emit('update:modelValue', val),
    });

    const prerequisites = computed(() => {
      const globalI18n = i18n.vueI18n.global;
      const locale = globalI18n.locale.value;
      const messages = globalI18n.getLocaleMessage(locale);
      const items = messages.taxReductionInfo.prerequisites;
      return items as Array<string>;
    });

    return { t, internalValue, prerequisites };
  },
});
</script>

<style scoped>
ul.pt-3 {
  list-style: disc;
  margin-left: 20px;
}
ul.pt-3 li {
  margin-bottom: 12px;
}
/* header title styling from image picker */
.modal-title {
  font-family: 'Lato', sans-serif;
  font-size: 20px;
  font-weight: 700;
  color: #1F2A37;
  line-height: 1.2;
}
.tax-info-intro {
  font-weight: 700;
}
</style>
